import { Directive, ElementRef, Renderer } from '@angular/core';

@Directive({
  selector: '[header-text-color]'
})
export class HeaderTextColorDirective {

  constructor(
    private el: ElementRef,
    private renderer: Renderer
  ) {
    this.setColor();
  }

  setColor() {
    let text_color = '#000000';
    if (localStorage.getItem('header_data') && localStorage.getItem('header_data') != '') {
      let header_data = JSON.parse(localStorage.getItem('header_data'));
      if (header_data['color']) {
        text_color = header_data['color'];
      }
    }

    this.renderer.setElementStyle(this.el.nativeElement, 'color', text_color);
  }
}



// WEBPACK FOOTER //
// ./src/directives/header-text-color/header-text-color.ts